import { render, staticRenderFns } from "./reply-form.vue?vue&type=template&id=4bdca9d0"
import script from "./reply-form.vue?vue&type=script&lang=js"
export * from "./reply-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports